import PricingPreview from './PricingPreview.component';

export default PricingPreview;